import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

import HandApp from "images/hand_app.png";

export const EnergyMonitoring = () => (
  <Section
    css={`
      @media screen and (min-width: ${getSize("tablet720")}) {
        justify-content: flex-end;
      }
    `}
  >
    <StaticQuery
      query={graphql`
        query EnergyMonitoringHeroImageQuery {
          file(relativePath: { eq: "monitor.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt="Someone using a mobile application to monitor their appliance's energy consumption"
          css={`
            + picture > img,
            img {
              object-position: 72% 50%;
              @media screen and (min-width: ${getSize("mobile375")}) {
                width: 240%;
                object-position: -105vw 50%;
              }
              @media screen and (min-width: ${getSize("tablet960")}) {
                width: 100%;
                object-position: 50% 50%;
              }
              @media screen and (min-width: ${getSize("desktop1200")}) {
                object-position: 50% 25%;
              }
            }
          `}
          file={file}
        />
      )}
    />
    <Image
      css={`
        bottom: 0;
        left: -7px;
        object-fit: contain;
        object-position: 50% 100%;
        position: absolute;
        right: 0;
        top: 0;
        @media screen and (min-width: ${getSize("tablet720")}) {
          object-position: -220px 100%;
          width: 648px;
        }
        @media screen and (min-width: ${getSize("tablet768")}) {
          object-position: -220px 100%;
          width: 670px;
        }
        @media screen and (min-width: ${getSize("tablet960")}) {
          display: none;
        }
      `}
      src={HandApp}
    />
    <Card
      css={`
        @media screen and (min-width: 0px) and (max-width: 719px) {
          padding-right: 34px;
        }
        @media screen and (min-width: ${getSize("tablet720")}) {
          width: 337px;
        }
        @media screen and (min-width: ${getSize("tablet768")}) {
          width: 361px;
        }
        @media screen and (min-width: ${getSize("tablet960")}) {
          width: 420px;
        }
        @media screen and (min-width: ${getSize("desktop1200")}) {
          width: 446px;
        }
        @media screen and (min-width: ${getSize("desktop1920")}) {
          padding: 74px 80px;
          width: 613px;
        }
      `}
    >
      <Header2
        css={`
          width: 260px;
          @media screen and (min-width: ${getSize("mobile480")}) {
            width: auto;
          }
          @media screen and (min-width: ${getSize("desktop1200")}) {
            width: 380px;
          }
          @media screen and (min-width: ${getSize("desktop1920")}) {
            width: 390px;
          }
        `}
      >
        {"Energy Monitoring"}
        <Underlined />
      </Header2>
      <Paragraph
        css={`
          @media screen and (min-width: 0px) and (max-width: 719px) {
            margin-top: 20px;
          }
          @media screen and (min-width: ${getSize("desktop1920")}) {
            width: 460px;
          }
        `}
      >
        {
          "Homeowners and businesses can view how much and where energy is being used. Viewing by time of day, load, circuit or group of circuits delivers information to make adjustments and control energy costs."
        }
      </Paragraph>
    </Card>
  </Section>
);
